import { StoreBadges } from '@maverick/ui';
import * as Styled from './Banner.styled';

export interface BannerProps {
	text?: JSX.Element;
	footerText?: JSX.Element;
	bgImage: string;
	storeBadges: boolean;
	iosLink?: string;
	androidLink?: string;
}

export const Banner: React.FC<BannerProps> = ({ text, footerText, storeBadges, bgImage, iosLink, androidLink }) => {
	return (
		<Styled.Container bgImage={bgImage}>
			<Styled.Banner>
				{!!text && <h2 data-testid='textBanner'>{text}</h2>}

				{storeBadges && (
					<div>
						<StoreBadges
							iosLink={iosLink != undefined ? iosLink : ''}
							androidLink={androidLink != undefined ? androidLink : ''}
						/>
					</div>
				)}
				{!!footerText && <p data-testid='footerTextBanner'>{footerText}</p>}
			</Styled.Banner>
		</Styled.Container>
	);
};
